import React from "react";

import Layout from "./Layout";
import _ from "lodash";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import AddWidgetPanel from "./AddWidgetPanel";
import { DragDropContext, DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import windowSize from "react-window-size";
import styles from "./style.css";
import { CircularProgress } from "@material-ui/core";
import { fetchWidgetDataV2 } from "../../../redux/actions/dashboardActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PlusCircle from "mdi-material-ui/PlusCircle";

export const defaults = {
  widgetWidth: 250,
  widgetHeight: 250,
  margin: 15
};

class Dashboard extends React.Component {
  state = {};

  displayName() {
    return "Dashboard";
  }

  // # optimize re-render to exclude width changes unless they affect column count
  shouldComponentUpdate(nextProps, nextState) {
    this.layout.reset(nextProps.componentWidthForTesting || nextState.componentWidth);
    const cc1 = this.layout.columnCount();
    this.layout.reset(this.state.componentWidth);

    const cc2 = this.layout.columnCount();
    return (
      nextProps !== this.props ||
      nextProps.editMode !== this.props.editMode ||
      nextProps.moveMode !== this.props.moveMode ||
      cc1 !== cc2
    );
  }

  childComponentsForConfig(components, config, editMode, moveMode, sizeConfig, columnCount, doneButtonClass) {
    const componentsById = getComponentsById(components);
    let rows = [];
    const instances = config.map(widget => {
      if (componentsById[widget.widgetId]) {
        let withPositionsAndRows = this.layout.setWidgetPosition(componentsById[widget.widgetId], widget.config);
        rows.push(parseInt(withPositionsAndRows[1]));
        return React.cloneElement(withPositionsAndRows[0], {
          dashEditable: editMode,
          draggable: moveMode,
          key: widget.instanceId,
          onConfigChange: this.configChange,
          onHide: () => {
            return this.hideWidget(widget.instanceId);
          },
          config: widget.config,
          instanceId: widget.instanceId,
          sizeConfig,
          columnCount,
          onDrop: this.moveWidget,
          doneButtonClass
        });
      }
    });
    return [_.compact(instances), Math.max(...rows)];
  }

  hideWidget(instanceId) {
    const allConfigs = [].concat(this.props.config);

    const index = _.findIndex(allConfigs, config => config.instanceId === instanceId);

    allConfigs.splice(index, 1);

    return this.props.onConfigChange(allConfigs);
  }

  configChange = (instanceId, newConfig) => {
    let allConfigs = [].concat(this.props.config);

    const index = _.findIndex(allConfigs, config => config.instanceId === instanceId);

    allConfigs[index] = {
      widgetId: allConfigs[index].widgetId,
      instanceId: instanceId,
      config: newConfig
    };

    return this.props.onConfigChange(allConfigs);
  };

  addWidget(id) {
    const config = [].concat(this.props.config);
    config.push({
      widgetId: id,
      instanceId: Math.floor(Math.random() * 100000),
      config: {}
    });
    return this.props.onConfigChange(config);
  }

  moveWidget = (draggingWidgetId, targetWidgetId) => {
    let config = [].concat(this.props.config);
    let targetIndex = _.findIndex(config, widget => widget.instanceId === targetWidgetId);
    const sourceIndex = _.findIndex(config, widget => widget.instanceId === draggingWidgetId);
    if (sourceIndex < targetIndex) {
      targetIndex--;
    }

    config.splice(targetIndex, 0, config.splice(sourceIndex, 1)[0]);
    return this.props.onConfigChange(config);
  };

  renderAddWidgets() {
    if (this.props.editMode && !this.props.moveMode) {
      const addPanelChildren = this.props.children.map((child, i) => {
        const preview = child.props.previewComp ? (
          React.createElement(child.props.previewComp)
        ) : (
          <div className="default-preview" key={child.props.id}>
            No Preview
          </div>
        );
        return (
          <div className="widget-preview" key={child.props.id} onClick={() => this.addWidget(child.props.id)}>
            <div className="no-click">{preview}</div>
            <div className="widget-preview-plus-icon">
              <PlusCircle className="icon fontSizeLarge" />
            </div>
          </div>
        );
      });

      return (
        <CSSTransition classNames="widget-panel" timeout={{ enter: 500, exit: 300 }}>
          <AddWidgetPanel leftSidebar={this.props.sidebarIsOpen} rightSidebar={this.props.rightSidebarIsOpen}>
            {addPanelChildren}
          </AddWidgetPanel>
        </CSSTransition>
      );
    }
  }
  handleResize = () => {
    this.setState({
      componentWidth: window.innerWidth
    });
  };

  handleResizeDrawers = () => {
    // only on desktop size it resizes dashboard widget container
    // because on smaller screens ( <1280px ) <main> is full width
    let isDesktop = window.innerWidth >= 1280;
    const sidebarIsOpen = this.props.sidebarIsOpen;
    const rightSidebarIsOpen = this.props.rightSidebarIsOpen;
    let componentWidth = this.state.componentWidth;

    if (sidebarIsOpen && rightSidebarIsOpen && isDesktop) {
      componentWidth = componentWidth - 542;
    } else if ((sidebarIsOpen && isDesktop) || (rightSidebarIsOpen && isDesktop)) {
      componentWidth = componentWidth - 271;
    }
    return componentWidth;
  };

  componentDidMount() {
    this.handleResize();
    this.props.fetchWidgetDataV2({
      startDate: this.props.dashboardDates.fromDateISO,
      endDate: this.props.dashboardDates.toDateISO
    });
    window.addEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dashboardDates !== this.props.dashboardDates) {
      this.props.fetchWidgetDataV2({
        startDate: this.props.dashboardDates.fromDateISO,
        endDate: this.props.dashboardDates.toDateISO
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    let {
      parentStyle,
      children,
      title,
      className,
      config,
      widgetHeight = defaults.widgetHeight,
      widgetWidth = defaults.widgetWidth,
      widgetMargin = defaults.margin,
      titleHeight = 50,
      doneButtonClass = "",
      moveMode,
      editMode
    } = this.props;

    children = [].concat(children);

    let sizeConfig = { widgetHeight, widgetWidth, widgetMargin, titleHeight };

    // this.layout = layout = new Layout(sizeConfig);
    this.layout = new Layout(sizeConfig);

    this.layout.reset(this.props.componentWidthForTesting || this.handleResizeDrawers());

    let childrenForCurrentConfig = this.childComponentsForConfig(
      children,
      config,
      editMode,
      moveMode,
      sizeConfig,
      this.layout.columnCount(),
      doneButtonClass
    );

    let contentWidth = this.layout.columnCount() * (widgetWidth + widgetMargin) - widgetMargin;

    let contentHeight = String(280 * childrenForCurrentConfig[1]) + "px";

    if (this.layout.columnCount() === 1) {
      contentWidth = "90%";
    }

    return (
      <div className={`dashboard ${className} ${editMode && !moveMode ? "editing" : ""}`} style={parentStyle}>
        {/*<Title height={titleHeight}>*/}
        {/*    {title}*/}
        {/*</Title>*/}
        <div className="dashboard-container">
          <div
            className={`dashboard-content columns-${this.layout.columnCount()}`}
            style={{ width: contentWidth, height: contentHeight }}
          >
            {this.state.componentWidth && !this.props.isFetchingData ? (
              childrenForCurrentConfig[0]
            ) : (
              <div style={{ width: "40px", marginLeft: "auto", marginRight: "auto" }}>
                <CircularProgress />
              </div>
            )}
          </div>
        </div>
        <TransitionGroup>{this.renderAddWidgets()}</TransitionGroup>
      </div>
    );
  }
}

const style = {
  settings: {
    position: "absolute",
    width: "45px",
    height: "45px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    color: "white"
  }
};

// module.exports = DragDropContext(HTML5Backend)(windowSize(Dashboard))
// module.exports.defaults = defaults

function mapStateToProps(state, ownProps) {
  return {
    dashboardDates: state.dashboard.widgetFromToDate,
    isFetchingData: state.dashboard.isFetchingData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchWidgetDataV2
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);

const getComponentsById = components => {
  const byId = {};
  components.forEach(comp => (byId[comp.props.id] = comp));
  return byId;
};
